import { useState, useRef, useEffect } from "react";

const REGIONS = [
  { value: "Europe", label: "Europe" },
  { value: "Americas", label: "Americas" }
];

// Map regions to their countries
const REGION_COUNTRIES = {
  Europe: [
    "UK", "United Kingdom", "Germany", "France", "Netherlands", "Belgium", 
    "Sweden", "Poland", "Hungary", "Switzerland", "Greece", "Malta", 
    "Bulgaria", "Croatia", "Czech Republic", "Denmark", "Ireland", 
    "Portugal", "Romania", "Slovakia", "Spain", "Serbia", "Italy"
  ],
  Americas: [
    "USA", "United States", "US", "Canada", "Costa Rica", "Colombia", 
    "Mexico", "Argentina", "Brazil", "Chile", "Peru"
  ]
};

export default function RegionSelector({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const selectedRegion = REGIONS.find((r) => r.value === value) || REGIONS[0];

  return (
    <div className="region-selector" ref={dropdownRef}>
      <button
        className="region-selector__button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className="region-selector__label">Region:</span>
        <span className="region-selector__value">{selectedRegion.label}</span>
        <span className={`region-selector__arrow ${isOpen ? "region-selector__arrow--open" : ""}`}>
          ▼
        </span>
      </button>
      {isOpen && (
        <div className="region-selector__dropdown" role="listbox">
          <ul className="region-selector__list">
            {REGIONS.map((region) => (
              <li
                key={region.value}
                className={`region-selector__option ${
                  value === region.value ? "region-selector__option--selected" : ""
                }`}
                role="option"
                aria-selected={value === region.value}
                onClick={() => {
                  onChange({
                    value: region.value,
                    label: region.label
                  });
                  setIsOpen(false);
                }}
              >
                {region.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

// Export helper function to get countries for a region
export function getCountriesForRegion(region) {
  if (!region || region === "all") {
    return null;
  }
  return REGION_COUNTRIES[region] || [];
}

// Export helper function to check if a country belongs to a region
export function isCountryInRegion(country, region) {
  if (!region || region === "all") {
    return true;
  }
  const regionCountries = REGION_COUNTRIES[region] || [];
  if (!regionCountries.length) return true;
  
  const countryLower = String(country).toLowerCase();
  return regionCountries.some(rc => {
    const rcLower = String(rc).toLowerCase();
    return countryLower === rcLower ||
           countryLower.includes(rcLower) ||
           rcLower.includes(countryLower);
  });
}
